import { storeCreator } from '@/utils/store/store.utils';
  
  
interface State {
  isDuplicateModalVisible: boolean;
  setIsDuplicateModalVisible: (isVisible: boolean) => void;
}
  
export const useStore = storeCreator<State>((set) => ({
  isDuplicateModalVisible: false,
  
  setIsDuplicateModalVisible: (isVisible) => set((state) => ({
    ...state,
    isDuplicateModalVisible: isVisible,
  })),
}));
  